module.exports = __webpack_public_path__ + "static/icon-grey-3e32c4bc2f078d8d0ce3940decb6e41e.jpg";